export default "__VITE_ASSET__2b0962ed__"